// @ts-ignore
export const underTest = !!globalThis.Cypress;

export const NOTISTACK_MAX_SNACKS = 3;
export const LAST_SELECTED_BRANCH = 'lastSelectedBranch';

export const ZOHO_SIGN_ORGANIZATION_ID = 655695013;

export const ZOHO_SIGN_EXTENSION_LINK_HOLDERS = {
  SalesProId: '${SalesPro.SalesProId}',
  SalesProName: '${SalesPro.SalesProName}',
  OrganizationId: '${Organization.OrganizationId}',
  Module: '${ModuleName}',
};

export const ZOHO_SIGN_EXTENSION_LINK =
  'https://sign.zoho.com/api/v1/integrations/zohocrm/homepage?module=${ModuleName}&record_id=${SalesPro.SalesProId}&record_name=${SalesPro.SalesProName}&crmzgid=${Organization.OrganizationId}';

export const SOW_TEMPLATE_TOOLS_ENABLED = false;
